var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThumbs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 5H8C6.34315 5 5 6.34315 5 8V14M14 5H20C21.6569 5 23 6.34315 23 8V14M14 5V23M14 23H20C21.6569 23 23 21.6569 23 20V14M14 23H8C6.34315 23 5 21.6569 5 20V14M23 14H5",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export { SvgThumbs as ReactComponent };